import * as React from "react";
import { useEffect } from "react";
import UsersService from "@velocity-ehs/user-utils-module";
import i18n from "../translations/i18n";
import { useFlags } from "launchdarkly-react-client-sdk";

export type SessionContextType = {
  invalidSession?: boolean;
  isLoading?: boolean;
};

const SessionContext = React.createContext<SessionContextType>({});

type Props = {
  children?: React.ReactNode;
};

const SessionProvider: React.FC<Props> = ({ ...props }) => {
  const featureFlags = useFlags();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const finishLoading = async () => {
    if (featureFlags.enableTranslationsAPI) {
      const { translations, lang } = await UsersService.i18nService.init();
      i18n.addResourceBundle(lang, "translation", translations, true, true);
    }
    i18n.changeLanguage(UsersService.user.preferredLanguage);
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);

    UsersService.initSessionUser(featureFlags)
      .then(finishLoading)
      .catch((error) => {
        /* eslint-disable-next-line no-console */
        console.log(error);
      });
    // eslint-disable-next-line
  }, []);

  return (
    <SessionContext.Provider
      value={{
        isLoading,
      }}
    >
      {props.children}
    </SessionContext.Provider>
  );
};

export { SessionContext, SessionProvider };
